module.exports = __webpack_public_path__ + "img/light_illu_bertrand.e6332537.png";